export const SEARCH_TYPES = {
    physicalAccessoryItem: 'physicalAccessoryItem',
    physicalContainerItem: 'physicalContainerItem',
    numericContainerItem: 'numericContainerItem',
    physicalMuseumItem: 'physicalMuseumItem',
}